import { render, staticRenderFns } from "./AllNotifications.vue?vue&type=template&id=d427b7e6&"
import script from "./AllNotifications.vue?vue&type=script&lang=js&"
export * from "./AllNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports